# Fun Facts About Honey Badger
## 2023/12/02

Did you know that the Guinness Book of Records named this animal as the most fearless animal? They are true fighters - bees, porcupines, cobras, scorpions, crocodiles, leopards, hyenas, lions, you name it. The tales of honey badger's sheer audacity have become the stuff of legend.

![honeybadger_on_ground 1 alt ><](https://b2177947.smushcdn.com/2177947/wp-content/uploads//Amapa.png?lossy=1&strip=1&webp=1)

### 1. They are small

The honey badgers are compact, typically measuring around 22 ~ 27cm (9 ~ 11 inches) in height at the shoulder, 55 ~ 77cm (20 ~ 30inches) in width, and weighing between 5.5 ~ 16kg(12 ~ 35lb). This is about the size of a large corgi.

### 2. They eat honey

Just as the name suggests, honey badgers like honey. And they can surely survive bee stings. Their coarse hair, loose-fitting skin, and fat layer make them highly impervious. For the record, knifes and spears won’t penetrate either, so don't use them. It'll just piss them off.

Another fun fact is badgers can't properly digest beeswax. But they still eat them.

![honey_badger 2 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/honeybadger3.png?raw=true)

### 3. They eat porcupines
These African crested porcupines boast lengthy, sharp, and lethal quills. They have been known to injure or even kill lions, leopards, hyenas, and humans.

But of course, our badgers will not surrender. 

![honeybadger_w_snake 2 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/honeybadger2.png?raw=true)

### 4. They eat (deadly) snakes

Our relentless honey badgers have developed immunity over their life time after numerous small injetcions of venom from bees, scorpions, and snakes.

![honeybadger_w_snake 1 alt ><](https://cdn.jwplayer.com/v2/media/CpXdNWGV/poster.jpg?width=480)

The snakes they eat are not just average snakes though. They are one of the deadliest snakes on earth. It only takes two drops of black mamba venom to kill an adult human, and a single bite from a King Cobra can take down an elephant.

However, our honey badgers don't give a sh*t. They usually attack the snake's head, fall into a deep, hour long sleep, then wake up all refreshed to finish the rest of the snake.

![honeybadger_w_snake 2 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/honeybadger4.gif?raw=true)

### 5. They eat basically everything
The honey badgers are known to eat 60 different species. Their prey includes underground, venomous, underwater, flying, or tree-dwelling creatures, some of which are 100 times bigger than their size.

### 6. They are smart
Thanks to their diverse diet, honey badgers are trained to be remarkable problem solvers & possibly the top innovator in Africa. One true story - Stoffle, a rescued honey badger, escaped its shelter using wood, rocks, and mop. When the caretaker removed almost everything, the honeybadger used dirt to make its escape.

![honey_badger 1 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/honeybadger1.gif?raw=true)

### 7. They are reckless
One more fun fact about Stoffel. He got into a lion shelter and picked a fight. He was injured fairly badly but once he recovered, he escaped AGAIN and went right back for round 2 with the lions.

It's not uncommon to see honey badgers taking on lions, leopards, hyenas, and even elephants. Some scientists believe their aggressive nature is a defense mechanism they've honed over time.

### 8. Newborn cheetah cubs look like honey badgers
It has been hypothesized that baby cheetahs evolved to look like adult honey badgers. Because honey badgers are known for their toughness, few predators want to tangle with them, offering protection to the baby cheetahs.

![honey_badger cheetah alt ><](https://www.researchgate.net/profile/John-Oconnor-18/publication/332180393/figure/fig7/AS:743627844235270@1554306102333/Example-of-the-hypothesised-Batesian-mimicry-observed-between-the-honey-badger.jpg)

### 9. They fart
Like skunks, honey badgers have a gland at the base of their tail that stores a stinky liquid. When threatened, they drop their "stink bomb". It's more like a "bomb" because they can precisely target where they want to shoot the liquid. They also use it to mark their territory or stun the bees.

### 10. They castrate bigger animals
One particularly vicious tactic these smart honey badgers use on larger preys is to castrate them and then wait for the animal to weaken from bleeding. From many studies, people witnessed honey badgers going straight for the balls without hesitation.

### 11. They are mama boys and girls
Research in the southern Kalahari showed that cubs stayed with their mothers for a minimum of 14 months. This is significantly longer than their relatives, which may become independent at 3 months. And some people witnessed that mama honey badgers deliberately expose their young to bee stings for practice.

### 12. But they prefer their own company after that
Honey badgers prefer to be alone - probably a good news for all the other animals.

![honey_badger 3 alt ><](https://media.giphy.com/media/f8k6R32qjJGV2/giphy-downsized.gif)

Honey badgers taught me so many lessons: resilience in the face of challenges, problem-solving skills, audacity, and curiosity that make them one of the smartest and fearless animals, living life to their fullest. I hope they continue to be so awesome and happy.

**References**
- [Oregon zoo](https://www.oregonzoo.org/animals/african-crested-porcupine#:~:text=The%20tips%20of%20its%20quills,%2C%20hyenas%2C%20and%20even%20humans.)
- [A-z animals](https://a-z-animals.com/blog/these-honey-badgers-are-basically-genius-safe-crackers/)
- [Safari specialists](https://www.safarispecialists.net/news/men-scared-honey-badgers/)
- [PBS](https://www.pbs.org/video/nature-honey-badgers-masters-mayhem/)
- National Geographic